import { registerPlugin } from '@capacitor/core';
const DetectMobileServices = registerPlugin('DetectMobileServices', {
    web: () => import('./web').then(m => new m.DetectMobileServicesWeb()),
});
export * from './definitions';
export { DetectMobileServices };
//# sourceMappingURL=index.js.map